import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid } from '@material-ui/core';

export const StyledCaption = styled(Captions)`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin: 1px !important;
  }
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    font-weight: 500;
    margin-bottom: 0;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;
